import {
  MedicalRecordsViewingLinkResponseDto,
  ReferralService,
} from 'common/api';
import { serviceRequest } from 'utils/http';

export function medicalRecordsViewingLinkAPI(params: {
  referralId: string;
}): Promise<MedicalRecordsViewingLinkResponseDto> {
  return serviceRequest(() =>
    ReferralService.referralControllerGetMedicalRecordsViewingLink(
      params.referralId
    )
  );
}
